import instance from "../config";

// Agenda personal del usuario de la sesión (admin o digitador).
// compromiso: { id, descripcion, fecha: "YYYY-MM-DD" | null, hora: "HH:mm:ss" | null,
//   electorId, Elector: { id, cedula, nombres, apellidos } | null, lider, avisarCorreo,
//   cumplido, fechaCumplido, createdAt }

// -> [compromiso]
export const getAgenda = async () => {
  const { data } = await instance.get("/agenda");
  return data.compromisos ?? [];
};

// vacíos a null: compromiso sin fecha, sin hora o sin relación
const cuerpoCompromiso = ({ descripcion, fecha, hora, electorId, lider, avisarCorreo }) => ({
  descripcion,
  fecha: fecha || null,
  hora: fecha && hora ? hora : null,
  electorId: electorId || null,
  lider: lider || null,
  avisarCorreo,
});

export const crearCompromisoAgenda = async (compromiso) => {
  const { data } = await instance.post("/agenda", cuerpoCompromiso(compromiso));
  return data;
};

export const editarCompromisoAgenda = async (id, compromiso) => {
  const { data } = await instance.put(`/agenda?id=${id}`, cuerpoCompromiso(compromiso));
  return data;
};

export const editarEstadoAgenda = async (id, cumplido) => {
  const { data } = await instance.put(`/agenda/estado?id=${id}`, { cumplido });
  return data;
};

export const eliminarCompromisoAgenda = async (id) => {
  const { data } = await instance.delete(`/agenda?id=${id}`);
  return data;
};
